import memberViewModel from "@contents/viewModels/memberViewModel";
import {useEffect} from "react";
import {SpaceBrandCodeGetApiInMyMenu} from "@services/dataSource/spaceApi";
import {SpaceBrandCodePayload} from "@services/entities/spaceEntity";
import {KEYS} from "@app/constants/keys";
import {SETTINGS} from "@app/constants/settings";
import SpaceViewModel from "@contents/viewModels/spaceViewModel";
import {useRecoilValue} from "recoil";
import {spaceState} from "@services/stores/storeState";
import {MemberCertifyAccessPutApiByMaster} from "@services/dataSource/memberApi";
import {MemberAccessPutPayload} from "@services/entities/memberEntity";
import {getCertifyErrorToast, getCertifySuccessToast} from "@utils/commonUtils";

export const AccessCertifyPageViewModel = () => {
    const {memberInfo, onMemberCertifyAccess} = memberViewModel();
    const {getSpaceAllList} = SpaceViewModel();

    const spaceInfo = useRecoilValue(spaceState);

    useEffect(() => {
        memberInfo?.baseRole === 'MASTER' && getSpaceAllList();
    }, [memberInfo?.baseRole]);

    const _getBrandCodeSpaceUrl = async () => {
        let spaceUrl = '';
        await SpaceBrandCodeGetApiInMyMenu<SpaceBrandCodePayload>({
            brandCode: memberInfo.brandCode || ''
        }).then((res) => {
            spaceUrl = (res?.content || '');
            sessionStorage.setItem(KEYS.MEMBER_BRAND_URL, SETTINGS.MNG_URL + spaceUrl);
        })

        return spaceUrl;
    }

    const isMaster = () => {
        return memberInfo?.baseRole === 'MASTER';
    }

    // 개인정보 접근 인증
    const onMemberCertifyAccessWithUser = async (payload: MemberAccessPutPayload) => {
        await _getBrandCodeSpaceUrl();

        const accessBrandCode = (spaceInfo.brandCode === '' ? spaceInfo.space : spaceInfo.brandCode) ?? '';
        const deviceInfo = spaceInfo.deviceInfo;

        await MemberCertifyAccessPutApiByMaster<MemberAccessPutPayload>({
            ...payload,
            accessBrandCode: accessBrandCode,
            deviceInfo: deviceInfo
        }).then((res) => {
            if (res && res.content) {
                getCertifySuccessToast();
                payload?.callback && payload?.callback();
            } else {
                getCertifyErrorToast();
            }
        }).catch((e) => {
            getCertifyErrorToast();
        })
    }


    return {
        onMemberCertifyAccess,
        isMaster,
        onMemberCertifyAccessWithUser
    }
}